import styled from 'styled-components';

export const ContainerList = styled.div`
    position: relative;

    .List {
        overflow-x: hidden !important;
    }
`;
